
export { PrimengDefaultWidgetRegistry } from './defaultwidget-registry';
